import { render, staticRenderFns } from "./CandidateCbrUser.vue?vue&type=template&id=a9938bb2&scoped=true&lang=pug"
import script from "./CandidateCbrUser.vue?vue&type=script&lang=js"
export * from "./CandidateCbrUser.vue?vue&type=script&lang=js"
import style0 from "./CandidateCbrUser.vue?vue&type=style&index=0&id=a9938bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9938bb2",
  null
  
)

export default component.exports